export const APPROVED_CONCEPT_ASSETS = Object.freeze([
  {
    id: 'concept.mockup.01',
    file: 'assets/concept/bolt-forge-mockup-01.png',
    screen: 'home',
    label: 'Main Menu / Home',
    sha256: '50d97ca50bdcebcfdd497795a3528982b8b1f4294f7775067c46281eb44938f3',
    width: 941,
    height: 1672,
    role: 'approved-concept-reference',
  },
  {
    id: 'concept.mockup.02',
    file: 'assets/concept/bolt-forge-mockup-02.png',
    screen: 'shop',
    label: 'Shop',
    sha256: 'b3a1bab31e40c6e89e9e7f073fa03f30175d46e44013788d1e11c642081e271f',
    width: 941,
    height: 1672,
    role: 'approved-concept-reference',
  },
  {
    id: 'concept.mockup.03',
    file: 'assets/concept/bolt-forge-mockup-03.png',
    screen: 'map',
    label: 'Map / Progression',
    sha256: '71e6e2c4312afb9363e73b0b545467851b1076553b9c4f9bbba31031ad81601c',
    width: 941,
    height: 1672,
    role: 'approved-concept-reference',
  },
  {
    id: 'concept.mockup.04',
    file: 'assets/concept/bolt-forge-mockup-04.png',
    screen: 'gameplay',
    label: 'Gameplay / Level Board',
    sha256: 'edb83be1962936aee8eb4a2c314f2d802964772947db46eca5cdd3a63b7fedba',
    width: 941,
    height: 1672,
    role: 'approved-concept-reference',
  },
]);

export function conceptAssetUrls() {
  return APPROVED_CONCEPT_ASSETS.map((asset) => new URL(`../../${asset.file}`, import.meta.url).href);
}
